import { render, staticRenderFns } from "./FileMenu.vue?vue&type=template&id=b323f2e8&"
import script from "./FileMenu.vue?vue&type=script&lang=ts&"
export * from "./FileMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports